import { render, staticRenderFns } from "./pieIcon.vue?vue&type=template&id=9f0893b0&"
import script from "./pieIcon.vue?vue&type=script&lang=js&"
export * from "./pieIcon.vue?vue&type=script&lang=js&"
import style0 from "./pieIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports